import { Component, ViewEncapsulation, OnInit, HostListener, ElementRef } from '@angular/core';
import { ModalScroll } from './shared/services/api-services/modal-scroll.service';
import { Subscription, Observable } from 'rxjs/';
import { Router, NavigationEnd, ActivatedRoute, NavigationStart, RouterModule } from '@angular/router';
import { SessionTimeoutService } from 'src/app/shared/services/api-services/session-timeout.service';
import { Store } from '@ngrx/store';
import { AppState } from './store/state/app.state';
import { UtilService, QuoteDataCaptureService,  ApplicationDataCaptureService, AuthService } from 'src/app/shared';
import { CURRENT_ENVIROMENT, SERVICE_END_POINT } from './shared/index';
import { Location } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { AlertModal } from 'src/app/model/alert';
import { AnalyticsService } from 'src/app/shared';
import { RefNo } from './model/ngrx';
import { Title } from '@angular/platform-browser';
import { filter } from 'rxjs/operators';
import { STORE_VAL } from 'src/app/shared/constants/store-val.constant';

import { PageLoaderComponent } from './common-components';


@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    encapsulation: ViewEncapsulation.None,
    imports: [RouterModule, PageLoaderComponent]
})

export class AppComponent implements OnInit{
  title = 'Digital Customer Journey';
  flag: boolean = false;
  sessionTimeLaps: boolean;
  private subscriptn: Subscription;
  displayFlag = false;
  loginDetails: any[];
  loginDetailsStore: Observable<any[]>;
  private endPoints = SERVICE_END_POINT[CURRENT_ENVIROMENT.environment];
  unSupportedBrowser=false;
  protected cmsDataunsupportedResolution: any;
  public isLocked:boolean=false;
  protected lockedAlertModalConfig: AlertModal;
  referenceNumberStore: Observable<RefNo[]>;
  referenceNumber: RefNo;
  CMSData;
  constructor(private modalScrollService: ModalScroll, private router: Router,
              private _sessionTimeoutSrv: SessionTimeoutService,
              private store: Store<AppState>, private myUtilService: UtilService,
              private quoteDatacaptureService: QuoteDataCaptureService,
              private applicationDataCaptureService: ApplicationDataCaptureService,
              private location: Location,
              private httpClient: HttpClient,
              private analyticsService: AnalyticsService,
              private utilService: UtilService,
              private activatedRoute: ActivatedRoute,
              private titleService: Title,
              private elementRef:ElementRef, private authService: AuthService) {
    
    this.loginDetailsStore = this.store.select(STORE_VAL.loggedin_detail);
    this.loginDetailsStore.subscribe((val) => {
      if (val.length > 0) {
        this.loginDetails = val[0];
      }
    });

    this.referenceNumberStore = this.store.select(STORE_VAL.ref_no);
    this.referenceNumberStore.subscribe((val: any) => {
      if (val.length > 0) {
        this.referenceNumber = val[0];
        }
    });
  
  }


  async ngOnInit() {
    this.elementRef.nativeElement.removeAttribute("ng-version")
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd),
    ).subscribe(() => {
      const rt = this.getChild(this.activatedRoute);
      rt.data.subscribe(data => {
        this.titleService.setTitle(data.title);
      });
    });
    this.analyticsService.initScript();
    this.disableScroll();
    if(this.loginDetails) {
      this._sessionTimeoutSrv.startTimer();
    }
   
    this._sessionTimeoutSrv.timeoutExpried.subscribe(res => {
      if (this.sessionTimeLaps) {
        // Irrespective of the selection YES/NO after addOnTime laps navigate to login page.
        // Before auto logoff; check if other tab is active
        if (this._sessionTimeoutSrv.getLocalSession() === 'false') {
          this.expireSessionHandler();
        } else {
          this.extendSessionHandler();
        }
      } else {
        if(this.loginDetails && this.router.url !== '/home/logout') {
          this.sessionTimeLaps = true;
          this.displayFlag = true;
          this._sessionTimeoutSrv.addonTime();
        // tslint:disable-next-line: max-line-length
        } else if ((this.router.url !== '/home/logout') && (this.router.url !== '/home/get-your-online-quote') && !((this.router.url.includes('ho-underwriting')))) {
          this.sessionTimeLaps = true;
          this.displayFlag = true;
          this._sessionTimeoutSrv.addonTime();
        }
      }
    });
    if (!this.getBrowserName()) {
      this.router.navigate(['/home/un-support', 'browser']);
    }
    this.httpClient.get(this.endPoints.contentDataUrl).subscribe(res=>{
      this.lockedAlertModalConfig=res['modalConfigLocked'];
      this.cmsDataunsupportedResolution=res['unsupportedResolution'];
      this.GetCMSDataService();
    }
   );
    this.myUtilService.isLocked$.subscribe(res => {
      if (res) {
        this.isLocked = true;
      } else {
        this.isLocked = false;
      }
    });
    await this.authService.redirection();
    // code for browser refresh button click
    if (performance.navigation.type === performance.navigation.TYPE_RELOAD) {
      const url = window.location.href;
      if (!(url.includes('/home/logout') || url.includes('/home/get-your-online-quote'))) {
        this.authService.logout();
      }
    }
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        window.scrollTo({ top: 0, behavior: 'smooth' }); // 👈 manually scroll to top
      }
    });
  }


  extendSessionHandler() {
    if (this.loginDetails) {
      this.sessionTimeLaps = false;
      this._sessionTimeoutSrv.resetTimer();
      this.displayFlag = false;
    } else {
      this.sessionTimeLaps = false;
      this._sessionTimeoutSrv.resetTimer();
      this.displayFlag = false;
    }


  }

  expireSessionHandler() {
    this.sessionTimeLaps = false;
    this._sessionTimeoutSrv.stopTimer();
    this.displayFlag = false;
    if (this.loginDetails) {
      if (this.router.url.indexOf('/home/get-your-online-quote')>-1
        || this.router.url.indexOf('/home/you-will-need')>-1
        || this.router.url === '/quote/your-saved-quotes'
        || this.router.url === '/quote/your-product-quote'
        || ((this.router.url.includes('ho-underwriting')))
      ) {
        this.authService.logout();
      } else {
        if(this.router.url.indexOf('/apply')>-1) {
          this.applicationDataCaptureService.onLogoutClick();
        } else {
          this.quoteDatacaptureService.onLogoutClick();
        }
      }
    } else {
      this.authService.logout();
    }
  }

  @HostListener('document: mousemove', ['$event'])
  @HostListener('document: click', ['$event'])
  @HostListener('document: wheel', ['$event'])
  @HostListener('document: keyup', ['$event']) onKeyUpListener() {
    if(this.loginDetails && this.router.url !== '/home/logout' && this.displayFlag !== true) {
      this.sessionTimeLaps = false;
      this._sessionTimeoutSrv.resetTimer();
    // tslint:disable-next-line: max-line-length
    } else if (this.router.url !== '/home/logout' && this.router.url !== '/home/get-your-online-quote' && this.router.url !== '/home/you-will-need' && !((this.router.url.includes('ho-underwriting')))   && this.displayFlag !== true) {
      this.sessionTimeLaps = false;
      this._sessionTimeoutSrv.resetTimer();
    }

  }
  ngOndestroy() {
    this.subscriptn.unsubscribe();
    sessionStorage.setItem('logInClicked', 'N');
  }

  disableScroll() {
    this.subscriptn = this.modalScrollService.scrollFlagState.subscribe(res => {

      if (res.scrollModalFlag === true) {

        (document.querySelector('.test') as HTMLElement).style.position = 'fixed';
        (document.querySelector('.test') as HTMLElement).style.overflow = 'hidden';
      }

      if (res.scrollModalFlag === false) {
        (document.querySelector('.test') as HTMLElement).style.position = 'absolute';
        (document.querySelector('.test') as HTMLElement).style.overflow = 'hidden';

      }
    });
  }
  public getBrowserName() {
    const nav = (window.navigator as any); 
    const isIE = /^.*MSIE [1-10]/i.test(nav.userAgent);
    if (isIE) {
      // alert('you are using older version of IE .........');
      return false;
    }
    const agent = nav.userAgent.toLowerCase();
    switch (true) {
      case agent.indexOf('opr/') > -1:
      return false;
      case agent.indexOf('yabrowser/') > -1:
      return false;
      case agent.indexOf('chrome') > -1 && !!(<any>window).chrome: {
        const fullVersion = navigator.userAgent.substring(navigator.userAgent.indexOf("Chrome") + 7);
        const actualVersion = fullVersion.substr(0, fullVersion.indexOf('.'))
        if (parseInt(actualVersion) < 78) {
          return true;
        } else {
          return true;
        }
      }
      case agent.indexOf('firefox') > -1:
        {
          // tslint:disable-next-line:max-line-length
          const actualVersion = Number.isNaN(parseInt(agent.substring(agent.lastIndexOf('/') + 1, agent.length))) ? 0 : parseInt(agent.substring(agent.lastIndexOf('/') + 1, agent.length));

          if (actualVersion < 64) {
            return false;
          } else {
            return true;
          }
        }
      case agent.indexOf('safari') > -1: {
        const fullVersion = navigator.userAgent.substring(navigator.userAgent.indexOf("Version") + 8);
        const actualVersion = fullVersion.substr(0, fullVersion.indexOf('.'))
        if (parseInt(actualVersion) < 11) {
          return false;
        } else {
          return true;
        }

      }
      case agent.indexOf('trident/') > -1:
      return true;
      case agent.indexOf('edge') > -1:
        return true;
      default:
        return false;
    }
  }
  closeLockedModal() {
    this.isLocked=false;
  }
  GetCMSDataService() {
    const URL =  SERVICE_END_POINT.higherEnvironment.CMS_Unsupported;
    this.utilService.getCMSData(URL)
    .subscribe(res => {
      this.CMSData = res;
      if(this.CMSData) {
      /** In the line below we are over-writing the contentData object values with CMSData object values */
        this.cmsDataunsupportedResolution.header = this.CMSData.string_ResolutionNotSupportedTitle;
        this.cmsDataunsupportedResolution.Detail = this.CMSData.string_ResolutionNotSupportedText;
      }
    });
  }
  getChild(activatedRoute: ActivatedRoute) {
    if (activatedRoute.firstChild) {
      return this.getChild(activatedRoute.firstChild);
    } else {
      return activatedRoute;
    }
  }
}
